export const BAD_AUCTIONS = ['0xEd4A285845f19945b0EbC04a3165e3DCAf62fEeD', '0x595Ff4d3Cebb8Bf652C198481A82F6A4440f551c']
export const TOPIC_ADDED_COMMITMENT = '0x077511a636ba1f10551cc7b89c13ff66a6ac9344e8a917527817a9690b15af7a'
export const NATIVE_PAYMENT_TOKEN = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'
